<script setup>
import CloseButton from "@/components/modal/common/closeButton.vue";
import {useLanguageStore} from "@/pinia";
import {ref} from "vue";
const languageStore = useLanguageStore();



const imagePath =  ref(null)
const pdfName = ref('')
const imgPath = require('@/assets/pdfImg.png')

const props = defineProps(['dataSnsNm'])
const emits = defineEmits(['close'])


const openHandler= (pdfApp)=>{
  window._pdfApp = pdfApp;
}
const closeBtn = ()=> {
  emits('close');
}
const pdfChange = ()=>{
  let name = props.dataSnsNm;
  if(name === 'twitter') {
    pdfName.value = 'Twitter X api key '+ languageStore.get('issuanceManual');
    imagePath.value = require('@/assets/xApi.pdf').default

  } else if(name === 'youtube') {
    pdfName.value = "Youtube Api key " + languageStore.get('issuanceManual');
    imagePath.value = require('@/assets/youtubeApi.pdf').default

  } else if(name === 'meta') {
    pdfName.value = "Facebook Api key " + languageStore.get('issuanceManual');
    imagePath.value = require('@/assets/metaApi.pdf').default

  }
}
</script>

<template>
<div>
  <div class="modal">
    <div class="modal-content">
      <div class="downPpt">
        <p class="topTitle">Download</p>
        <hr class="hrTag">
        <p class='title'>{{dataSnsNm}} Key {{languageStore.get('downloadManualConfirm')}}</p>
        <div class="imgContainer">
          <div class="pdfImgWrapper">
            <a @click="pdfChange" :href="imagePath" :download="pdfName" class="pptBtn"><img class= "pdfImg" style="cursor: pointer;" @click="pdfChange" :src="imgPath" ></a>
          </div>
        </div>
        <div class="downLoad">
          <p class="pdfNm">{{dataSnsNm}} Key {{languageStore.get('issuanceManual')}}.pdf</p>
          <button  @click="pdfChange" type="button" class=" btnD"><v-icon >mdi-download</v-icon><a :href="imagePath" :download="pdfName" class="pptBtn">{{languageStore.get('download')}}</a></button>
        </div>
      </div>
      <div class='contentNm'>
        <close-button @click="closeBtn" class="clsBtn"></close-button>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.downLoad{
  display: flex;
  margin: 20px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.pdfNm {
  text-align: center;
  margin: 30px 15px 30px 30px;
}
.topTitle {
  text-align: center;
  font-weight: bold;
  color: #243d6c;
  font-size: 24px;
}
.imgContainer {
  display: flex;
  justify-content: center;
}
.pdfImgWrapper {
  width: 150px; 
  height: 150px; 
  border-radius: 50%; 
  background-color: rgba(65, 154, 255, 0.377); 
  border: 2px solid transparent; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdfImg {
  width: 100px; 
  height: 100px; 
}

.pptBtn{
  color: white;
}

.btnD {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #052C65;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
}

.downPpt{
    justify-content: center;
    margin-top: 20px;
}

.keyNm1 {
  display: inline-block;
  width: 210px;
  min-width: 80px;
}

.contentNm {
  display: flex;
  align-items: center;
  justify-content: center !important;
}


.title {
  text-align: center;
  margin: 20px 10px 10px 10px;
  height: 20px;
  padding: 25px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  width: 35vw;
  padding: 20px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

</style>